
import React from 'react';
import { Button } from './Button';
import { ArrowRightLeft, Check, X, User, Loader2 } from 'lucide-react';

interface Props {
  transfers: any[]; // Project objects
  senderNames: Record<string, string>;
  onRespond: (projectId: string, action: 'accept' | 'reject') => void;
  processingId?: string | null; // Neuer Prop für Ladezustand
}

export const ProjectTransferModal: React.FC<Props> = ({ transfers, senderNames, onRespond, processingId }) => {
  if (transfers.length === 0) return null;

  return (
    <div data-glass-view="projekt-dialog" className="fixed inset-0 z-[200] bg-black/60 backdrop-blur-sm flex items-center justify-center p-4 animate-fade-in">
      <div className="bg-white rounded-2xl shadow-2xl w-full max-w-lg overflow-hidden animate-scale-in">
        <div className="bg-indigo-600 text-white p-5 flex justify-between items-center">
          <div className="flex items-center gap-3">
            <div className="bg-white/20 p-2 rounded-lg">
                <ArrowRightLeft className="w-6 h-6 text-white" />
            </div>
            <div>
                <h3 className="font-bold text-lg">Projekteingang</h3>
                <p className="text-indigo-100 text-xs">Jemand möchte Projekte an Sie übertragen.</p>
            </div>
          </div>
        </div>
        
        <div className="p-6 bg-slate-50 max-h-[60vh] overflow-y-auto space-y-3">
            {transfers.map(project => {
                const isProcessing = processingId === project.id;
                
                return (
                    <div key={project.id} className="bg-white border border-slate-200 rounded-xl p-4 shadow-sm">
                        <h4 className="font-bold text-slate-800 text-lg mb-1">{project.name}</h4>
                        <div className="flex items-center gap-2 text-sm text-slate-500 mb-4">
                            <User className="w-4 h-4" />
                            <span>Von: <strong>{senderNames[project.user_id] || 'Unbekannt'}</strong></span>
                        </div>
                        
                        <div className="flex gap-3">
                            <Button 
                                onClick={() => onRespond(project.id, 'reject')}
                                disabled={isProcessing || !!processingId} // Disable all if one is processing to prevent race conditions
                                className="flex-1 justify-center bg-white border border-red-200 text-red-600 hover:bg-red-50 disabled:opacity-50"
                            >
                                <X className="w-4 h-4 mr-2" /> Ablehnen
                            </Button>
                            <Button 
                                onClick={() => onRespond(project.id, 'accept')}
                                disabled={isProcessing || !!processingId}
                                className="flex-1 justify-center bg-emerald-600 hover:bg-emerald-700 text-white disabled:opacity-50"
                            >
                                {isProcessing ? (
                                    <Loader2 className="w-4 h-4 mr-2 animate-spin" />
                                ) : (
                                    <Check className="w-4 h-4 mr-2" />
                                )}
                                {isProcessing ? 'Verarbeite...' : 'Annehmen'}
                            </Button>
                        </div>
                    </div>
                );
            })}
        </div>
      </div>
    </div>
  );
};
